import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { CheckIcon, ChevronLeftIcon } from "../../../constants/Icons";

const Success = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const verifyToken = location.state?.verifyToken;
    const Redirect = location.state?.Redirect;
    const label = location.state?.label;

    useEffect(() => {
        if (!verifyToken || !Redirect) {
            navigate(`/login}`);
        }
    }, [verifyToken, navigate, Redirect]);

    return (
        <div class="wrapper bg-back">
            <div class="authentication-reset-password d-flex align-items-center justify-content-center">
                <div class="container">
                    <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                        <div class="col mx-auto">
                            <div className="mb-5 text-center">
                                <img src="assets/images/logo-image.png" width="150" alt="" />
                            </div>
                            <div class="card">
                                <div class="card-body text-center">
                                    <div className="p-4">
                                        <div className="mb-3">
                                            <CheckIcon iClass={"success-circle text-white fs-20"}/>
                                        </div>
                                        <div class="text-center mb-3">
                                            <h5 class="mb-2">Email Sent!</h5>
                                            <p class="mb-0">Check your email &amp; change your password</p>
                                        </div>
                                        <div className="col-12">
                                            <div class="text-center">
                                                <Link to={`/${Redirect}`} class="d-flex align-items-center justify-content-center">
                                                  <ChevronLeftIcon iClass={"me-1 fs-18"}/>
                                                    {label}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Success;